module.exports = __webpack_public_path__ + "static/media/skeleton.a4f1a81a.svg";